import { useQuery } from '@tanstack/react-query'
import { PublicStripePaymentProfileEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetPaymentProfilePublic(paymentProfileId: string): {
  paymentProfile: PublicStripePaymentProfileEntity
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: paymentProfile,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(['paymentProfile', paymentProfileId], async () => {
    return qoursesApi.paymentPublic.paymentPublicControllerGetStripePaymentProfileV1(
      paymentProfileId,
    )
  })

  return { paymentProfile, isLoading, isError, refetch, isRefetching }
}
